import React, { createContext, useCallback, useState } from 'react';
import styled from 'styled-components';

const ClickBlockingContext = createContext({
  setShouldBlock: (_: boolean) => {}
});

const OverlayPosition = styled.div`
  position: relative;
`;

const Overlay = styled.div`
  background-color: green;
  opacity: 0;
  cursor: progress;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: var(--layers-application-top);
`;

const ClickBlockingProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children
}) => {
  const [shouldBlock, setShouldBlock] = useState(false);
  const debugSetShouldBlock = useCallback(
    (value: boolean) => {
      console.log('here');
      setShouldBlock(value);
    },
    [setShouldBlock]
  );

  return (
    <ClickBlockingContext.Provider
      value={{ setShouldBlock: debugSetShouldBlock }}
    >
      <OverlayPosition>
        {shouldBlock && <Overlay />}
        {children}
      </OverlayPosition>
    </ClickBlockingContext.Provider>
  );
};

export default ClickBlockingContext;
export { ClickBlockingProvider };
